// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IOcrAddressDto } from './IOcrAddressDto';
import {
    IOcrAddressDtoFromJSON,
    IOcrAddressDtoFromJSONTyped,
    IOcrAddressDtoToJSON,
    IOcrAddressDtoToJSONTyped,
} from './IOcrAddressDto';

/**
 * 
 * @export
 * @interface IOcrProviderDto
 */
export interface IOcrProviderDto {
    /**
     * 
     * @type {string}
     * @memberof IOcrProviderDto
     */
    facility_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IOcrProviderDto
     */
    tax_id?: string;
    /**
     * 
     * @type {IOcrAddressDto}
     * @memberof IOcrProviderDto
     */
    address_dto?: IOcrAddressDto;
}

/**
 * Check if a given object implements the IOcrProviderDto interface.
 */
export function instanceOfIOcrProviderDto(value: object): value is IOcrProviderDto {
    return true;
}

export function IOcrProviderDtoFromJSON(json: any): IOcrProviderDto {
    return IOcrProviderDtoFromJSONTyped(json, false);
}

export function IOcrProviderDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOcrProviderDto {
    if (json == null) {
        return json;
    }
    return {
        
        'facility_name': json['facility_name'] == null ? undefined : json['facility_name'],
        'tax_id': json['tax_id'] == null ? undefined : json['tax_id'],
        'address_dto': json['address_dto'] == null ? undefined : IOcrAddressDtoFromJSON(json['address_dto']),
    };
}

export function IOcrProviderDtoToJSON(json: any): IOcrProviderDto {
    return IOcrProviderDtoToJSONTyped(json, false);
}

export function IOcrProviderDtoToJSONTyped(value?: IOcrProviderDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'facility_name': value['facility_name'],
        'tax_id': value['tax_id'],
        'address_dto': IOcrAddressDtoToJSON(value['address_dto']),
    };
}

